import React, { useState } from 'react';
import { Button, TextField, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    
  } from '@mui/material';
import CustomButton from "../CommonComponents/CustomButton";
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomCancelButton from '../CommonComponents/CustomCancelButton';
import axios from 'axios';
import { useSelector } from "react-redux";
import { Checkbox, Typography } from '@mui/material';
import { saveUserForm } from '../../Restclient/datacollection';

function epochToIndianTimestamp(epochSeconds) {
  // Convert seconds to milliseconds for Date object 
  let wenttime = new Date(epochSeconds * 1000); 
  let wenttimeyear = wenttime.getFullYear().toString(); 
  let wenttimemonth = (wenttime.getMonth() + 1).toString().padStart(2, "0"); 
  let wenttimedaydate = wenttime.getDate().toString().padStart(2, "0"); 
  let wenttimehour = wenttime.getHours().toString().padStart(2, "0"); 
  let wenttimeminute = wenttime.getMinutes().toString().padStart(2, "0"); 
  let wenttimesec = wenttime.getSeconds().toString().padStart(2, "0"); 
  let wenttimemsec = wenttime.getMilliseconds().toString().padStart(3, "0"); // Format: YYYY-MM-DD HH:MM:SS.mmm 
  return `${wenttimeyear}-${wenttimemonth}-${wenttimedaydate} ${wenttimehour}:${wenttimeminute}:${wenttimesec}.${wenttimemsec}`; 
}

const UserFormResponse = ({ id, maintenanceinfo, template, lastmaintenanceperformeddate, maintenanceintervaldays, nextmaintenancedate, responsesobtained }) => {
  const themechange = useSelector((state) => state.themedata.theme)
  const [devicesdata, setDevicesData] = useState([])
  const [responses, setResponses] = useState(
    template.map((question) => ({
      question: question.description,
      response: question.responseType === 'Multiple Choice' ? '' : null,
      responseType: question.responseType,
      CheckListItemID: question.CheckListItemID
    }))
  );
  
  const devicedetailsobject = useSelector((state) => state.mainpagedata.devicedetailsobject);
  const handleResponseChange = (index, value) => {
    const updatedResponses = responses.map((response, i) =>
      i === index ? { ...response, response: value } : response
    );
    setResponses(updatedResponses);
  };
  const [confirmSaveChangesDialog, setConfirmSaveChangesDialog] = useState(false);

  const saveUserFormcallback = (response) => {
    setConfirmSaveChangesDialog(false)
  }

  function handleSave(){
    
    // alert('Responses saved successfully!');
    // // Here, you would send the responses to the backend using axios or fetch
    // axios.post('http://localhost:4000/save-responses', responses)
    //   .then(() => alert('Responses saved to the server!'))
    //   .catch((error) => console.error('Error saving responses:', error));
    setConfirmSaveChangesDialog(true)
  };

  function handleconfirmSaveChangesDialogSave(){
      var objecttosave = {
        id:id,
        DeviceID : maintenanceinfo,
        responses : responses
      }
      
      saveUserForm(objecttosave,saveUserFormcallback);
      
  }

  function handleconfirmSaveChangesDialogClose(){
    setConfirmSaveChangesDialog(false)
  }

  
  return (
    <div style={{ border: '1px solid #ccc', padding: '20px'}}>
      
      <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Device : {devicedetailsobject[maintenanceinfo]?.Name}</Typography>
        { 
            responsesobtained.map((currentpointer, index)=>{
                return(
                    <div>
                        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>Maintenance Performed Date : {epochToIndianTimestamp(currentpointer.performeddate)}</Typography>
                        {currentpointer.response.map((question, index) => (
                           
                            <div key={index} style={{ margin: '20px 0' }}>
                                <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",textAlign:"left",marginTop:"0px"}}>{question.question}</Typography>
                                {question.responseType === 'Yes/No' && (
                                <RadioGroup
                                    row
                                    value={question.response || ''}
                                    disabled={true}
                                >
                                    <FormControlLabel 
                                        sx={{
                                        "&:before": {
                                            borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                        },
                                        "&:hover:not(.Mui-disabled):before": {
                                            borderBottom: '2px solid #008CD7',
                                        },
                                        "&:after": {
                                            borderBottom: '2px solid #008CD7',
                                        },
                                        margin: 0,
                                        padding: 0,
                                        width: '100px',
                                        fontSize: "18px",
                                        fontFamily: "Roboto",
                                        fontWeight: '700 !important',
                                        color: 'var(--PrimaryText)',
                                        '& .MuiInputBase-input': {
                                            paddingLeft: 0
                                        },
                                        '& .MuiInputBase-input:focus': {
                                            color: 'var(--HighlightedText_Stroke)',
                                            borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                            backgroundColor: 'transparent',
                                            fontWeight: '700 !important',
                                            '& .MuiSvgIcon-root': {
                                                color: 'var(--HighlightedText_Stroke) !important'
                                            },
                                        },
                                        '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                            color: 'var(--HighlightedText_Stroke)',       //not working
                                        },
                                        '& .MuiSvgIcon-root': {
                                            color: 'var(--PrimaryText)'
                                        },
                                        '& .MuiNativeSelect-select': {
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                        },
                                        '& .MuiNativeSelect-select option': {
                                            backgroundColor: 'var(--dropdown-bg) !important',
                                            fontSize: "18px",
                                            fontFamily: "Roboto",
                                            fontWeight: 400,
                                            color: 'var(--PrimaryText) !important',
                                            borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                        },
                                        '& .MuiNativeSelect-select option:checked': {
                                            backgroundColor: 'var(--dropdown-bg) !important',
                                            color: 'var(--White) !important',
                                            fontWeight: '700 !important',
                                            borderColor: '2px solid var(--HighlightedText_Stroke)'
                                        },
                                        '& .MuiInputBase-input option:hover': {
                                            backgroundColor: '#005D8F !important',
                                        },
                        
                                    }}
                                    MenuProps={{
                                        PaperProps:{
                                            sx:{
                                                width:"100px",
                                                bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                                borderBottom:'2px solid #008CD7',
                                                borderRadius:0,
                                                boxShadow:'none',
                                                maxHeight:'250px',
                                                overflow:'auto',
                                                color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                            }
                                        },               
                                    }}   value="Yes" control={<Radio />} label="Yes" />
                                    <FormControlLabel 
                                        sx={{
                                            "&:before": {
                                                borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                            },
                                            "&:hover:not(.Mui-disabled):before": {
                                                borderBottom: '2px solid #008CD7',
                                            },
                                            "&:after": {
                                                borderBottom: '2px solid #008CD7',
                                            },
                                            margin: 0,
                                            padding: 0,
                                            width: '100px',
                                            fontSize: "18px",
                                            fontFamily: "Roboto",
                                            fontWeight: '700 !important',
                                            color: 'var(--PrimaryText)',
                                            '& .MuiInputBase-input': {
                                                paddingLeft: 0
                                            },
                                            '& .MuiInputBase-input:focus': {
                                                color: 'var(--HighlightedText_Stroke)',
                                                borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                                backgroundColor: 'transparent',
                                                fontWeight: '700 !important',
                                                '& .MuiSvgIcon-root': {
                                                    color: 'var(--HighlightedText_Stroke) !important'
                                                },
                                            },
                                            '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                                color: 'var(--HighlightedText_Stroke)',       //not working
                                            },
                                            '& .MuiSvgIcon-root': {
                                                color: 'var(--PrimaryText)'
                                            },
                                            '& .MuiNativeSelect-select': {
                                                paddingTop: 0,
                                                paddingBottom: 0,
                                            },
                                            '& .MuiNativeSelect-select option': {
                                                backgroundColor: 'var(--dropdown-bg) !important',
                                                fontSize: "18px",
                                                fontFamily: "Roboto",
                                                fontWeight: 400,
                                                color: 'var(--PrimaryText) !important',
                                                borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                            },
                                            '& .MuiNativeSelect-select option:checked': {
                                                backgroundColor: 'var(--dropdown-bg) !important',
                                                color: 'var(--White) !important',
                                                fontWeight: '700 !important',
                                                borderColor: '2px solid var(--HighlightedText_Stroke)'
                                            },
                                            '& .MuiInputBase-input option:hover': {
                                                backgroundColor: '#005D8F !important',
                                            },
                    
                                            }}
                                            MenuProps={{
                                                PaperProps:{
                                                    sx:{
                                                        width:"100px",
                                                        bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                                        borderBottom:'2px solid #008CD7',
                                                        borderRadius:0,
                                                        boxShadow:'none',
                                                        maxHeight:'250px',
                                                        overflow:'auto',
                                                        color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                                    }
                                                },               
                                            }}  value="No" control={<Radio />} label="No" />
                                </RadioGroup>
                                )}
                                {question.responseType === 'Multiple Choice' && (
                                <RadioGroup
                                    row
                                    value={question.response || ''}
                                    onChange={(e) => handleResponseChange(index, e.target.value)}
                                >
                                    {question.options.map((option, oIndex) => (
                                    <FormControlLabel 
                                        sx={{
                                        "&:before": {
                                            borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                        },
                                        "&:hover:not(.Mui-disabled):before": {
                                            borderBottom: '2px solid #008CD7',
                                        },
                                        "&:after": {
                                            borderBottom: '2px solid #008CD7',
                                        },
                                        margin: 0,
                                        padding: 0,
                                        width: '100px',
                                        fontSize: "18px",
                                        fontFamily: "Roboto",
                                        fontWeight: '700 !important',
                                        color: 'var(--PrimaryText)',
                                        '& .MuiInputBase-input': {
                                            paddingLeft: 0
                                        },
                                        '& .MuiInputBase-input:focus': {
                                            color: 'var(--HighlightedText_Stroke)',
                                            borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                            backgroundColor: 'transparent',
                                            fontWeight: '700 !important',
                                            '& .MuiSvgIcon-root': {
                                                color: 'var(--HighlightedText_Stroke) !important'
                                            },
                                        },
                                        '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                            color: 'var(--HighlightedText_Stroke)',       //not working
                                        },
                                        '& .MuiSvgIcon-root': {
                                            color: 'var(--PrimaryText)'
                                        },
                                        '& .MuiNativeSelect-select': {
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                        },
                                        '& .MuiNativeSelect-select option': {
                                            backgroundColor: 'var(--dropdown-bg) !important',
                                            fontSize: "18px",
                                            fontFamily: "Roboto",
                                            fontWeight: 400,
                                            color: 'var(--PrimaryText) !important',
                                            borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                        },
                                        '& .MuiNativeSelect-select option:checked': {
                                            backgroundColor: 'var(--dropdown-bg) !important',
                                            color: 'var(--White) !important',
                                            fontWeight: '700 !important',
                                            borderColor: '2px solid var(--HighlightedText_Stroke)'
                                        },
                                        '& .MuiInputBase-input option:hover': {
                                            backgroundColor: '#005D8F !important',
                                        },

                                        }}
                                        MenuProps={{
                                            PaperProps:{
                                                sx:{
                                                    width:"100px",
                                                    bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                                    borderBottom:'2px solid #008CD7',
                                                    borderRadius:0,
                                                    boxShadow:'none',
                                                    maxHeight:'250px',
                                                    overflow:'auto',
                                                    color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                                }
                                            },               
                                        }}key={oIndex} value={option} control={<Radio />} label={option} />
                                    ))}
                                </RadioGroup>
                                )}
                                {question.responseType === 'Descriptive' && (
                                <TextField
                                    fullWidth
                                    variant="standard"
                                    value={question.response || ''}
                                    sx={{marginLeft:"16px",marginTop:"0px",fontSize:"16px",fontFamily:"Roboto",marginLeft:"14px",
                                    '& .MuiInputBase-input:focus': {
                                        color: '#008CD7',
                                    },
                                    '& .MuiInputBase-root': {
                                        fontFamily: 'Roboto',
                                        fontSize: '16px',
                                        fontWeight: '700',
                                        color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                    },
                                    '& .MuiInput-root .MuiInputBase-input': {
                                        
                                    },
                                    '& .MuiInputBase-root::before': {
                                        borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                    },
                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                        borderBottom: '2px solid #008CD7',
                                    },
                                    '& .MuiInputBase-root::after': {
                                        borderBottom: '2px solid #008CD7',
                    
                                    },
                    }}
                                    onChange={(e) => handleResponseChange(index, e.target.value)}
                                    label=""
                                />
                                )}
                            </div>
                            ))
                        }
                    </div>
                )

            })
       }

        
       
    </div>
  );
};

export default UserFormResponse;
